export default __webpack_public_path__ + "static/media/double.fdf13de6.png";